import React from 'react';

import BundleEditView from '@components/shared/bundles/BundleEditView';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';

import adminBundleService from '@services/admin/bundleService';
import adminProductService from '@services/admin/productService';

interface MerchantDataValue {
  inventoryTypes?: { id: string; name: string }[];
}

const AdminBundleNew: React.FC = () => {
  const { inventoryTypes } = useMerchantData() as MerchantDataValue;

  return (
    <BundleEditView
      bundleService={adminBundleService as any}
      productService={adminProductService as any}
      inventoryTypes={inventoryTypes}
      role="admin"
    />
  );
};

export default AdminBundleNew;
